import axios from 'axios';
import _ from 'lodash';

export default {
  init(apiURL, userEmail, userToken) {
    console.log(`API_URL: ${apiURL}`);
    this.axios = axios.create({
      baseURL: apiURL
    });

    if (!userEmail || !userToken) {
      console.log('Missing user email or token');
    }

    this.axios.defaults.headers.common['x-aug-user-email'] = userEmail;
    this.axios.defaults.headers.common['x-aug-user-token'] = userToken;
  },

  async validateUserToken() {
    let response = {};
    if (this.axios.defaults.headers.common['x-aug-user-token']) {
      response = await this.axios.post('colgate/validateUserToken');
    } else {
      console.log('Skipping validateUserToken (missing)');
    }
    return _.get(response, 'data.valid', false);
  },

  async getLocationEquipment(locationFilter) {
    let url = 'colgate/locationequipment';
    if (locationFilter) {
      url = `${url}?locationFilter=${locationFilter}`;
    }
    let response = await this.axios.get(url);
    return response.data;
  },

  async getPriorities() {
    let response = await this.axios.get('colgate/priorities');
    return response.data;
  },

  async getSAPId() {
    let response = await this.axios.get('colgate/sapid');
    return response.data;
  },

  async createNotification(newNotification, Maintplant, PmWkctr) {
    const body = {
      FunctLoc: newNotification.FunctLoc,
      Maintplant,
      Equipment: newNotification.equipmentId,
      PmWkctr,
      Priority: newNotification.priority,
      ShortText: newNotification.shortDesc,
      Longtext: newNotification.longDesc,
      SAPId: newNotification.SAPId
    }

    console.log('Creating new notification', JSON.stringify(body));

    let response = await this.axios.post('colgate/notification', body);

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/services/notificationService.js